/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-27 11:26:23
 */
import FindPasswordForm from "../components/FindPassword";
import "../index.less";
import Brand from "@/components/brand/brand";
import React from "react";

const FindPassword = () => {
	return (
		<div className="findPassword">
			<div className="brand">
				<Brand logoSize={"3rem"} fontSize={"1.75rem"}/>
			</div>
			<div className="form">
				<FindPasswordForm/>
			</div>
		</div>
	);
};

export default FindPassword;
